(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Timeseries', Timeseries);

    Timeseries.$inject = ['$resource'];

    function Timeseries ($resource) {
        var resourceUrl =  'api/timeseries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
